import { getApi } from '../../../comm/middleware/callApi';
import apis from '../../../comm/api/apis';

/**
 * 获取收益记录
 * @param commit
 * @param curpage
 */
export const getIncome = ({ commit }, { curpage = 1 }) => {
  return getApi({ commit }, apis.getIncome, { curpage })
  .then((body) => {
    return body.data;
  });
};
// 获取收益数值
export const getMyLightIncome = ({ commit }, params) => {
  return getApi({ commit }, apis.getMyIncome, params)
  .then((body) => {
    return body.data;
  });
};


// 课程子页考试信息
export const getExamInfo = ({ commit }, { courseid }) => {
  return getApi({ commit }, apis.getExamInfo, { courseid })
    .then((body) => {
      return body.data;
    });
};
// 提交听课子页试题 submitExam
export const submitExam = ({ commit }, { examsyllabusid, exercises }) => {
  return getApi({ commit }, apis.submitExam, { examsyllabusid, exercises })
    .then((body) => {
      return body.data;
    });
};

// cms广告图
export const getAdvert = ({ commit }, { advcode, protocol }) => {
  return getApi({ commit }, apis.adByCodes, { advcode, protocol })
    .then((body) => {
      return body.data;
    });
};

// 首页接口
export const getHomePage = ({ commit }, { openid }) => {
  return getApi({ commit }, apis.getHomePage, { openid })
    .then((body) => {
      return body.data;
    });
};

// 我的课堂列表
export const getMyCourse = ({ commit }, { pageno, pagesize, protocol }) => {
  return getApi({ commit }, apis.getMyCourse, { pageno, pagesize, protocol })
    .then((body) => {
      return body.data;
    });
};

// 首页是否发放优惠券
export const getHomeCoupon = ({ commit }) => {
  return getApi({ commit }, apis.getHomeCoupon)
    .then((body) => {
      return body.data;
    });
};

// 获取分享素材
export const getShareMaterial = ({ commit }, { protocol, bizid, biztype, groupId, activityId }) => {
  return getApi({ commit }, apis.getShareMaterial, { protocol, bizid, biztype, groupId, activityId })
    .then((body) => {
      return body.data;
    });
};

// 获取听课页课程详情
export const getLighthouseCourseDetail = ({ commit }, { protocol, courseid }) => {
  return getApi({ commit }, apis.getLighthouseCourseDetail, { protocol, courseid })
    .then((body) => {
      return body.data;
    });
};

// 获取子课程列表
export const getLighthouseCourseList = ({ commit }, { parentcourseid, curpage, pagesize, protocol }) => {
  return getApi({ commit }, apis.getLighthouseCourseList, { parentcourseid, curpage, pagesize, protocol })
    .then((body) => {
      return body.data;
    });
};

export const getInvite = ({ commit }, { page = 1 }) => {
  return getApi({ commit }, apis.getInvite, { page })
  .then((body) => {
    return body.data;
  });
};

// 课程详情
export const getCourseDetail = ({ commit }, { courseid, protocol }) => {
  return getApi({ commit }, apis.lightCourseDetail, { courseid, protocol })
    .then((body) => {
      return body.data;
    });
};

// 小灯塔子课程详情
export const getSimpleSubCourse = ({ commit }, { id, pid, protocol }) => {
  return getApi({ commit }, apis.simpleSubCourse, { id, pid, protocol })
    .then((body) => {
      return body.data;
    });
};

// 拼团汇总信息
export const getTopicCountInfo = ({ commit }, { courseid, sku, activityid, protocol }) => {
  return getApi({ commit }, apis.topicCountInfo, { courseid, sku, activityid, protocol })
    .then((body) => {
      return body.data;
    });
};

// 拼团实例信息
export const getTopicGroupInfo = ({ commit }, { courseid, sku, activityid, activityinstanceid, protocol }) => {
  return getApi({ commit }, apis.topicGroupInfo, { courseid, sku, activityid, activityinstanceid, protocol })
    .then((body) => {
      return body.data;
    });
};

// 预下单接口
export const lightForPreOrder = ({ commit }, params) => {
  return getApi({ commit }, apis.lightForPreOrder, params)
  .then((body) => {
    return body.data;
  });
};

// 提交订单
export const lightSubmitOrder = ({ commit }, params) => {
  return getApi({ commit }, apis.lightSubmitOrder, params)
  .then((body) => {
    return body.data;
  });
};

// 传递openid给接口 对openid进行保存
export const bindSaveOpenId = ({ commit, state }) => {
  return getApi({ commit }, apis.saveOpenId, { openid: state.userInfo.weixinUserInfo && state.userInfo.weixinUserInfo.openid });
};

// 课程详情跑马灯
export const getOrderTipList = ({ commit }, { sku }) => {
  return getApi({ commit }, apis.orderTipList, { sku })
    .then((body) => {
      return body.data;
    });
};
// 拼团价格信息
export const getCoursePrice = ({ commit }, { courseid, protocol }) => {
  return getApi({ commit }, apis.coursePrice, { courseid, protocol })
    .then((body) => {
      return body.data;
    });
};

// 服务电商 我的优惠券列表
export const getMyCoupon = ({ commit }, params) => {
  return getApi({ commit }, apis.myCoupon, params)
    .then((body) => {
      return body.data;
    });
};

// 优惠券立即使用商品列表
export const getSkuList = ({ commit }, { couponId }) => {
  return getApi({ commit }, apis.skuList, { couponId })
    .then((body) => {
      return body.data;
    });
};

// 优惠券立即使用商品列表
export const getMyOrders = ({ commit }, params) => {
  return getApi({ commit }, apis.getMyOrders, params)
  .then((body) => {
    return body.data;
  });
};



// WEBPACK FOOTER //
// ./src/store/user/lighthouse/actions.lighthouse.js